export default "__VITE_ASSET__DJHSRa7$__"